import React from 'react';
import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Box from '@mui/joy/Box';
import Sidebar from './components/Sidebar';
import ProtectedRoute from './components/ProtectedRoute';
import { LAYOUT } from './theme/layoutTokens';
import ClientList from './pages/clients/ClientList';
import ClientDetail from './pages/clients/ClientDetail';
import ClientForm from './pages/clients/ClientForm';
import ProductsHub from './pages/products/ProductsHub';
import ProductForm from './pages/products/ProductForm';
import ProductDetail from './pages/products/ProductDetail';
import BulkProductCreator from './pages/products/BulkProductCreator';
import CategoryForm from './pages/categories/CategoryForm';
import BulkCategoryCreator from './pages/categories/BulkCategoryCreator';
import BrandForm from './pages/brands/BrandForm';
import BulkBrandCreator from './pages/brands/BulkBrandCreator';
import AttributeForm from './pages/attributes/AttributeForm';
import AttributeSetForm from './pages/attribute-sets/AttributeSetForm';
import SaleList from './pages/sales/SaleList';
import SaleDetail from './pages/sales/SaleDetail';
import SaleForm from './pages/sales/SaleForm';
import Settings from './pages/settings/Settings';
import ChatPage from './pages/chat/ChatPage';
import LoginPage from './pages/LoginPage';
import Home from './pages/Home';

const PaddedLayout: React.FC = () => (
  <Box sx={{ flex: 1, overflow: 'auto', px: LAYOUT.contentPadding, py: { xs: 2, sm: 2.5, md: 3 } }}>
    <Outlet />
  </Box>
);

const MainShell: React.FC = () => (
  <Box sx={{ display: 'flex', height: '100vh', bgcolor: 'background.body' }}>
    <Sidebar />
    <Box
      component="main"
      sx={{
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Outlet />
    </Box>
  </Box>
);

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<MainShell />}>
          <Route path="/chat" element={<ChatPage />} />
          <Route element={<PaddedLayout />}>
            <Route path="/clients" element={<ClientList />} />
            <Route path="/clients/new" element={<ClientForm />} />
            <Route path="/clients/:reference/edit" element={<ClientForm />} />
            <Route path="/clients/:reference" element={<ClientDetail />} />
            <Route path="/products" element={<ProductsHub />} />
            <Route path="/products/new" element={<ProductForm />} />
            <Route path="/products/bulk" element={<BulkProductCreator />} />
            <Route path="/products/:reference/edit" element={<ProductForm />} />
            <Route path="/products/:reference" element={<ProductDetail />} />
            <Route path="/categories" element={<Navigate to="/products?tab=categories" replace />} />
            <Route path="/categories/new" element={<CategoryForm />} />
            <Route path="/categories/bulk" element={<BulkCategoryCreator />} />
            <Route path="/categories/:reference/edit" element={<CategoryForm />} />
            <Route path="/brands" element={<Navigate to="/products?tab=brands" replace />} />
            <Route path="/brands/new" element={<BrandForm />} />
            <Route path="/brands/bulk" element={<BulkBrandCreator />} />
            <Route path="/brands/:reference/edit" element={<BrandForm />} />
            <Route path="/attributes" element={<Navigate to="/products?tab=attributes" replace />} />
            <Route path="/attributes/new" element={<AttributeForm />} />
            <Route path="/attributes/:reference/edit" element={<AttributeForm />} />
            <Route path="/attribute-sets" element={<Navigate to="/products?tab=attribute-sets" replace />} />
            <Route path="/attribute-sets/new" element={<AttributeSetForm />} />
            <Route path="/attribute-sets/:reference/edit" element={<AttributeSetForm />} />
            <Route path="/sales" element={<SaleList />} />
            <Route path="/sales/new" element={<SaleForm />} />
            <Route path="/sales/edit/:saleReference" element={<SaleForm />} />
            <Route path="/sales/:saleReference" element={<SaleDetail />} />
            <Route path="/connections" element={<Navigate to="/settings" replace />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/" element={<Home />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
